import { css, CSSResult } from 'lit'
import { csFormControl } from 'elements/_shared/form.style.js'
import { csColorAction } from '@cloudsuite/mosaic-shared/styles/colors.style.js'
import { csSpacing } from '@cloudsuite/mosaic-shared/styles/spacing.style.js'
import { csTransition } from '@cloudsuite/mosaic-shared/styles/globals.style.js'


export const csePhoneNumberInput = {
  backgroundColor: css`var(--cse-phone-number-input-background-color, ${csFormControl.backgroundColor})`,
  backgroundColorDisabled: css`var(--cse-phone-number-input-background-color-disabled, ${csFormControl.backgroundColorDisabled})`,
  borderWidth: css`var(--cse-phone-number-input-border-width, ${csFormControl.borderWidth})`,
  borderColor: css`var(--cse-phone-number-input-border-color, ${csFormControl.borderColor})`,
  borderColorError: css`var(--cse-phone-number-input-border-color-error, ${csFormControl.borderColorError})`,
  borderColorSuccess: css`var(--cse-phone-number-input-border-color-success, ${csFormControl.borderColorSuccess})`,
  borderRadius: css`var(--cse-phone-number-input-border-radius, ${csFormControl.borderRadius})`,
  color: css`var(--cse-phone-number-input-color, ${csFormControl.color})`,
  colorDisabled: css`var(--cse-phone-number-input-color-disabled, ${csFormControl.colorDisabled})`,
  fontSize: css`var(--cse-phone-number-input-font-size, ${csFormControl.fontSize})`,
  fontFamily: css`var(--cse-phone-number-input-font-family, ${csFormControl.fontFamily})`,
  width: css`var(--cse-phone-number-input-width, 100%)`,
  gap: css`var(--cse-phone-number-input-gap, ${csSpacing.spacing05})`,
  height: css`var(--cse-phone-number-input-height, ${csFormControl.height})`,
  paddingInline: css`var(--cse-phone-number-input-padding-x, ${csFormControl.paddingInline})`,
  paddingBlock: css`var(--cse-phone-number-input-padding-y, ${csFormControl.paddingBlock})`,
  outlineFocus: css`var(--cse-phone-number-input-outline-focus, ${csFormControl.outlineFocus})`,
  placeholderColor: css`var(--cse-phone-number-input-placeholder-color, ${csFormControl.placeholderColor})`,
  prefixColor: css`var(--cse-phone-number-input-prefix-color, ${csColorAction.primary})`,
  suffixColor: css`var(--cse-phone-number-input-suffix-color, ${csFormControl.colorDisabled})`,
}

export const style: CSSResult = css`
  .cse-phone-number-input {
    position: relative;
    background: ${csePhoneNumberInput.backgroundColor};
    border-width: ${csePhoneNumberInput.borderWidth};
    border-style: solid;
    border-color: ${csePhoneNumberInput.borderColor};
    border-radius: ${csePhoneNumberInput.borderRadius};
    color: ${csePhoneNumberInput.color};
    font-size: ${csePhoneNumberInput.fontSize};
    font-family: ${csePhoneNumberInput.fontFamily};
    width: ${csePhoneNumberInput.width};
    height: ${csePhoneNumberInput.height};
    padding-block: ${csePhoneNumberInput.paddingBlock};
    padding-inline: ${csePhoneNumberInput.paddingInline};
    display: flex;
    gap: ${csePhoneNumberInput.gap};
    justify-content: space-between;
    align-items: center;
    transition-duration: ${csTransition.duration};
    transition-timing-function: ${csTransition.timingFunction};
    transition-property: color, background-color, border-color;
  }

  input {
    all: unset;
    width: inherit;
    height: ${csePhoneNumberInput.height};
    font-size: ${csePhoneNumberInput.fontSize};
    font-family: ${csePhoneNumberInput.fontFamily};
    flex: 1;
  }

  input[type=number]::-webkit-outer-spin-button,
  input[type=number]::-webkit-inner-spin-button {
    margin: 0;
    -webkit-appearance: none;
  }

  input[type=number] {
    -moz-appearance: textfield;
  }

  .cse-phone-number-input-prefix {
    color: ${csePhoneNumberInput.prefixColor};
    --cse-text-color: ${csePhoneNumberInput.prefixColor};
  }

  .cse-phone-number-input-suffix {
    color: ${csePhoneNumberInput.suffixColor};
    --cse-text-color: ${csePhoneNumberInput.suffixColor};
  }

  .cse-phone-number-input.disabled {
    background-color: ${csePhoneNumberInput.backgroundColorDisabled};
    color: ${csePhoneNumberInput.colorDisabled};
  }

  .cse-phone-number-input input::placeholder {
    color: ${csePhoneNumberInput.placeholderColor};
    opacity: 1;
  }

  .cse-phone-number-input:has(input:focus-visible) {
    outline: ${csePhoneNumberInput.outlineFocus};
  }

  .cse-phone-number-input.valid-error {
    border-color: ${csePhoneNumberInput.borderColorError};
  }

  .cse-phone-number-input.valid-success {
    border-color: ${csePhoneNumberInput.borderColorSuccess};
  }
`
